import type { TableFooterProps } from './TableFooter.types'

export const TableFooter = (props: TableFooterProps) => {
  const { children } = props

  return <div className="TableFooter">{children}</div>
}
